import { fetchVacancy } from "@/api/landing";

export default {
  namespaced: true,
  state: {
    vacancies: {},
    pagination: {
      currentPage: 1,
      total: 0,
      perPage: 10,
      lastPage: 1,
    },
    hasError: false,
  },

  mutations: {
    SET_VACANCIES(state, payload) {
      state.vacancies = payload;
      state.pagination = {
        currentPage: payload.current_page,
        total: payload.total,
        perPage: payload.per_page,
        lastPage: payload.last_page,
      };
      state.hasError = false;
    },
    SET_ERROR(state, status) {
      state.hasError = status;
    },
  },

  actions: {
    async loadVacancy({ commit }, { page = 1, filters = {} } = {}) {
      try {
        const response = await fetchVacancy({ page, ...filters });
        commit("SET_VACANCIES", response.data);
      } catch (error) {
        commit("SET_ERROR", true);
        console.error("Ошибка загрузки данных:", error);
      }
    },
  },

  getters: {
    getVacancy: (state) => state.vacancies || [],
    getPagination: (state) => state.pagination || {},
  },
};
